import React from 'react';
import cls from 'classnames';
import { Agreement } from '../../../models/Agreement';
import { AgreementMetadata } from '../../../models/AgreementMetadata';
import { AgreementListItem } from './AgreementListItem';
import styles from './agreement_list.module.scss';

type Props = {
  className?: string;
  agreements: Agreement[];
  animate?: boolean;
  query?: string;
  onRevise?: (agreement: Agreement, meta: AgreementMetadata) => void;
  onCancel?: (agreement: Agreement, meta: AgreementMetadata) => void;
  onDelete?: (agreement: Agreement, meta: AgreementMetadata) => void;
  onOrderCreated?: (agreement: Agreement, meta: AgreementMetadata, latestOrderId: string) => void;
}

/**
 * Renders a list of documents.
 */
export const AgreementList: React.FC<Props> = ({
  agreements,
  animate = true,
  className,
  onRevise,
  onCancel,
  onDelete,
  onOrderCreated,
  query
}) => {
  if (!agreements?.length) {
    return (
      <p className={styles.placeholder}>
        Avtal du skapat dyker upp här
      </p>
    )
  }

  return (
    <div className={cls([styles.list, className, animate ? styles.animated : false])} role="table">
      <div className={styles.item} role="row">
        <h3 className={styles.th} role="columnheader">Skapad</h3>
        <h3 className={styles.th} role="columnheader">Kund</h3>
        <h3 className={styles.th} role="columnheader">Status</h3>
        <h3 className={styles.th} role="columnheader">Visningar</h3>
        <h3 className={styles.th} role="columnheader">Dokument</h3>
      </div>
      {
        agreements.map(agreement => (
          <AgreementListItem
            key={agreement.key}
            agreement={agreement}
            query={query}
            animate={agreements.length < 8}
            onRevise={onRevise}
            onCancel={onCancel}
            onDelete={onDelete}
            onOrderCreated={onOrderCreated} />
        ))
      }
    </div>
  );
}